<div class="modal-content">
    <div class="modal-body">
        <div class="modal-toggle-wrapper">
            <!-- Imagen de advertencia -->
            <ul class="modal-img" *ngIf="image != ''">
                <li> <img [src]="image" alt="error"></li>
            </ul>

            <!-- Título de la modal -->
            <h4 class="text-center pb-2">{{title}}</h4>

            <!-- Descripción del mensaje -->
            <p class="text-center">
                {{description}}
            </p>

            <!-- Botones de confirmación -->
            <div class="text-center">
                <button class="btn btn-secondary me-2" type="button" (click)="close()">Cancelar</button>
                <button class="btn btn-danger ms-2" type="button" (click)="confirm()">Confirmar</button>
            </div>
        </div>
    </div>
</div>
